import React, { Component } from 'react';
import ShopifyModal from "../ShopifyModal";

import { Prompt, withRouter } from 'react-router-dom';
import intl from '../../../src/i18n/intl'
import utils from '../../utils/utils'
class SettingPrompt extends Component {
  state = {
    disabledSaveData: true,
    modalShow: false,
    nextUrl: '',
    currentUrl: '',
    saveData: null,
    save:true,
  }
  UNSAFE_componentWillReceiveProps = (prev) => {
    this.setState({
      disabledSaveData: prev.disabledSaveData,
      currentUrl: prev.url,
      saveData: prev.saveData,
      save:prev.save
    })
  }
  handleUrlChange = () => {
    if (this.state.nextUrl !== '') {
      if (!this.state.disabledSaveData) {
        utils.routeJump(this,this.state.nextUrl)
    }
    }

  };
  handleUrlClose = () => {
    this.setState({
      modalShow: false,
      // disabledSaveData: true
    })
  }
  handleClose = () => {
    this.setState({
      modalShow: false,
      // disabledSaveData: true
    })
  }
  render() {
    const { disabledSaveData, currentUrl } = this.state
    return (
      <div>
        <Prompt when={!disabledSaveData}
          message={(loc) => {
            if (loc.pathname !== currentUrl && !disabledSaveData) {
              this.setState({
                modalShow: true,
                nextUrl: loc.pathname
              })
            }
            return this.state.modalShow
          }} />
        <ShopifyModal id="setting-prompt"
          open={this.state.modalShow}
          onClose={this.handleClose}
          heading={intl.get('Edited info not saved')}
          primaryAction={{
            content: intl.get('Discard'),
            onAction:this.handleUrlChange,
          }}
          secondaryActions={[
            {
              content:intl.get('Cancel') ,
              onAction: this.handleUrlClose,
            },
          ]}
        >
          <p>
                {intl.get('Your edited information has not been saved, and will not be saved after leaving.')}
              </p>
             
          </ShopifyModal>
      </div>
    );
  }
}

export default withRouter(SettingPrompt);
